import { flash } from "./flash";
import moment from "moment";

function isBlank(value) {
  if (typeof value === "string") {
    return value === undefined || value === null || value.trim() === "";
  }
  return value === undefined || value === null;
}

function handleAjaxError(message, jqXHR) {
  let fullMessage = message;

  if (jqXHR.status === 422) {
    if (
      jqXHR.responseJSON &&
      jqXHR.responseJSON.errors &&
      jqXHR.responseJSON.errors.length > 0
    ) {
      fullMessage = `${fullMessage} ${jqXHR.responseJSON.errors[0]}`;
    }
  }
  flash("error", fullMessage);
}

function parseAjaxError(jqXHR, callback) {
  if (jqXHR.status === 422) {
    if (
      jqXHR.responseJSON &&
      jqXHR.responseJSON.errors &&
      jqXHR.responseJSON.errors.length > 0
    ) {
      callback(jqXHR.responseJSON.errors);
    }
  }
}

function findSelectOptionByValue(options, value) {
  let result;
  options.forEach((option) => {
    if (option.value === value) {
      result = option;
    }
  });
  return result;
}

function friendlyOptionalBoolean(value, nullResult = "(Unspecified)") {
  if (value === undefined || value === null) {
    return nullResult;
  }
  if (value === true) {
    return "Y";
  }
  return "N";
}

function friendlyDate(dateTime) {
  if (dateTime === undefined || dateTime === null) {
    return "";
  }
  return moment(dateTime).format("D MMMM YYYY");
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function absValueString(stringValue) {
  if (Number.isNaN(stringValue) || stringValue.trim() === "") {
    return "";
  }
  return String(Math.abs(parseFloat(stringValue)));
}

export {
  isBlank,
  parseAjaxError,
  handleAjaxError,
  findSelectOptionByValue,
  friendlyOptionalBoolean,
  capitalizeFirstLetter,
  absValueString,
  friendlyDate,
};
